import Handlebars from 'handlebars';
import moment from 'moment';
import AMApp from '../../global/app';

/**
 * FondsPrices Module (Plain JS)
 */
export default class FondsPrices {
  constructor(element, options = {}) {
    this.element = element;
    this.amApp = new AMApp();

    this.settings = {
      routeFondsdetail: AMApp.langGetParam + 'eID=fonds&function=fondsdetail&isin=',
      routeFondsprices: AMApp.langGetParam + 'eID=fonds&function=lastDayValues&fondsId=',
      ...options
    };

    this.statusInit = this.element.querySelectorAll('.js_status_init');
    this.statusNoResult = this.element.querySelectorAll('.js_status_noresult');
    this.statusErrorClass = 'js_status_error';
    this.resultTarget = document.getElementById('fondsprices_result_target');

    this.init();
  }

  init() {
    console.log('### FondsPrices ###');
    this.registerHandlebarsHelpers();

    // Event Delegation für Klicks auf Fonds-Elemente (data-andiid)
    this.element.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-andiid]');
      if (trigger) {
        event.preventDefault();
        const isin = trigger.dataset.isin;
        const andiid = trigger.dataset.andiid;
        this.getFondsData(isin, andiid);
      }
    });
  }

  registerHandlebarsHelpers() {
    // Helper: Euro Formatierung
    Handlebars.registerHelper("euroFromFloat", (value) => {
      if (value !== undefined && value !== null && value !== '') {
        const numValue = typeof value === 'string' ? parseFloat(value) : value;
        return (numValue.toFixed(2) + ' EUR').replace('.', ',');
      } else if (value === '0' || value === '00' || value === 0) {
        return '0,00 EUR';
      }
      return value;
    });

    // Helper: SQL Time to Date
    Handlebars.registerHelper("sqlTimeToDate", (value) => {
      if (value) {
        return moment(value).utc().format('DD.MM.YYYY');
      }
      return value;
    });
  }

  /**
   * Orchestriert die Datenabfrage (Details -> Preise -> Merge)
   */
  async getFondsData(isin, fondsId) {
    this.statusIsLoading();

    try {
      // 1. Fonds Details abrufen
      const detailUrl = AMApp.basePath + this.settings.routeFondsdetail + encodeURIComponent(isin);
      const detailResponse = await fetch(detailUrl);
      if (!detailResponse.ok) throw new Error('Detail request failed');
      const fondsData = await detailResponse.json();

      // 2. Letzte Tageswerte abrufen
      const pricesUrl = AMApp.basePath + this.settings.routeFondsprices + encodeURIComponent(fondsId);
      const pricesResponse = await fetch(pricesUrl);
      if (!pricesResponse.ok) throw new Error('Prices request failed');
      const fondsLastDayValues = await pricesResponse.json();

      this.success(fondsLastDayValues, fondsData);
    } catch (error) {
      this.fail(error);
    }
  }

  success(fondsLastDayValues, fondsData) {
    if (fondsLastDayValues && fondsData) {
      // Merge der Daten (Ersatz für _.merge)
      const data = {
        ...fondsData,
        INHI_AUSGABEPREIS: fondsLastDayValues.INHI_AUSGABEPREIS,
        INHI_DATUM: fondsLastDayValues.INHI_DATUM,
        INHI_RUECKNAHMEPREIS: fondsLastDayValues.INHI_RUECKNAHMEPREIS
      };
      this.renderFondsPriceData(data);
    } else {
      this.statusNoData();
    }
  }

  fail(error) {
    console.error('FondsPrices Fetch Error:', error);
    this.removeLoader();
    this.showFailMessage();
  }

  renderFondsPriceData(data) {
    if (data && this.resultTarget) {
      this.statusDataFound();
      const templateEl = document.getElementById('fondsprices_result_template');
      if (templateEl) {
        const compiledTemplate = Handlebars.compile(this.amApp.toHandlebarsDelimiters(templateEl.innerHTML));
        this.resultTarget.innerHTML = compiledTemplate(data);
      }
    } else {
      this.statusNoData();
    }
  }

  statusIsLoading() {
    if (this.statusInit.length > 0) {
      this.statusInit[0].insertAdjacentHTML('beforebegin', AMApp.LOADING_ANIMATION);
    }
    this.toggleStatusElements(this.statusInit, true);
    this.toggleStatusElements(this.statusNoResult, true);
    this.element.querySelectorAll('.' + this.statusErrorClass).forEach(el => el.remove());

    if (window.innerWidth <= AMApp.CONSTANTS.BREAKPOINT.LG) {
      const loader = this.element.querySelector('.loader');
      if (loader) {
        window.scrollTo({
          top: loader.getBoundingClientRect().top + window.scrollY,
          behavior: 'smooth'
        });
      }
    }
  }

  statusNoData() {
    this.toggleStatusElements(this.statusInit, true);
    this.toggleStatusElements(this.statusNoResult, false);
    this.removeLoader();
  }

  statusDataFound() {
    this.toggleStatusElements(this.statusInit, true);
    this.toggleStatusElements(this.statusNoResult, true);
    this.removeLoader();
  }

  showFailMessage() {
    const message = AMApp.translations.response.fail;
    const p = document.createElement('p');
    p.className = `result-status ${this.statusErrorClass}`;
    p.textContent = message;
    if (this.resultTarget) {
      this.resultTarget.after(p);
    }
  }

  toggleStatusElements(elements, shouldHide) {
    elements.forEach(el => el.classList.toggle('d-none', shouldHide));
  }

  removeLoader() {
    this.element.querySelectorAll('.loader').forEach(loader => loader.remove());
  }
}